import React from "react";
import { mdiCheckCircle, mdiCloseCircle, mdiHelpCircle } from "@mdi/js";
import AppModal from "./AppModal";
import MdiIcon from "../../device/app/MdiIcon";
import "../../../assets/styles/app-settings.css";

const ICONS = { confirmation: mdiHelpCircle, success: mdiCheckCircle, error: mdiCloseCircle };

// The app's CustomModal (app/components/CustomModal.js): an icon over the
// card, the title in the dialog's colour, the message, and "Ok" for errors and
// successes or "Cancel" / "Yes" for confirmations. confirmLabel replaces "Yes"
// where the action should be named.
const AlertDialog = ({ open, type = "error", title, message, onClose, onConfirm, confirmLabel = "Yes" }) => {
  const confirm = type === "confirmation";
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={title}
      className={`hx-set-modal is-${type}`}
      actions={
        confirm ? (
          <>
            <button type="button" className="hx-btn is-ghost" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="hx-btn" onClick={onConfirm}>
              {confirmLabel}
            </button>
          </>
        ) : (
          <button type="button" className="hx-btn" onClick={onClose}>
            Ok
          </button>
        )
      }
    >
      <div className={`hx-set-dialog is-${type}`}>
        <span className="hx-set-dialog-badge" aria-hidden="true">
          <span>
            <MdiIcon path={ICONS[type] ?? mdiCloseCircle} size={30} color="#fff" />
          </span>
        </span>
        <p className="hx-modal-text">{message}</p>
      </div>
    </AppModal>
  );
};

export default AlertDialog;
